export const ACCOUNT_ENUM = {
  ROLE_SELECT: "ROLE_SELECT",
  LOGIN: "LOGIN",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
};